<template>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
            <div class="text-[13px] font-semibold text-gray-900">
                Video Type
            </div>

            <form-checkbox
                v-for="videoType in videoTypes"
                :label="videoType.title"
                :checked-colors="['#FFFFFF', '#0685BB']"
                :unchecked-colors="['#DDE1EA', '#ffffff']"
                :px-width="22"
                label-classes="text-gray-625 text-[16px] font-medium"
                v-model="videoType.selected"
                v-on:update:modelValue="setTypes"
            />
        </div>
        <div class="">
            <div
                class="border-b border-gray-400 pb-2 text-[14px] font-semibold text-gray-900"
            >
                Focus Area
            </div>
            <div
                v-for="focusArea in focusAreas"
                class="text-[16px] text-gray-625"
            >
                <div :class="focusArea.expanded ? 'mb-4' : ''">
                    <div
                        class="flex items-start justify-between border-t border-gray-425 py-4 hover:cursor-pointer hover:bg-gray-225 hover:text-gray-725"
                        @click="toggleCategoriesVisible(focusArea)"
                    >
                        <div class="">
                            {{ focusArea.title }}&nbsp;({{
                                focusArea.categories.length
                            }})
                        </div>
                        <div>
                            <div
                                v-if="focusArea.expanded"
                                class="flex h-6 w-6 items-center justify-center"
                            >
                                <svg
                                    width="14"
                                    height="2"
                                    viewBox="0 0 14 2"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.16675 1H12.8334"
                                        stroke="#767C8D"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <div
                                v-else
                                class="flex h-6 w-6 items-center justify-center"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g opacity="0.7">
                                        <path
                                            d="M10 4.16699V15.8337"
                                            stroke="#767C8D"
                                            stroke-width="1.66667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M4.16675 10H15.8334"
                                            stroke="#767C8D"
                                            stroke-width="1.66667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="">
                        <transition name="list">
                            <div
                                class="flex flex-col gap-2"
                                v-if="focusArea.expanded"
                            >
                                <div class="">
                                    <span
                                        v-if="!focusArea.allCategoriesSelected"
                                        @click="selectAll(focusArea)"
                                        class="text-primary-525 underline hover:cursor-pointer hover:text-primary-600"
                                        >Select All</span
                                    >
                                    <span
                                        v-if="focusArea.allCategoriesSelected"
                                        @click="deselectAll(focusArea)"
                                        class="text-primary-525 underline hover:cursor-pointer hover:text-primary-600"
                                        >Deselect All</span
                                    >
                                </div>
                                <div
                                    v-for="category in focusArea.categories"
                                    class=""
                                >
                                    <form-checkbox
                                        :label="category.title"
                                        :checked-colors="['#FFFFFF', '#0685BB']"
                                        :unchecked-colors="[
                                            '#DDE1EA',
                                            '#ffffff',
                                        ]"
                                        :px-width="22"
                                        label-classes="text-gray-625 text-[16px] font-medium"
                                        v-model="category.selected"
                                        v-on:update:modelValue="setCategories"
                                    />
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FormCheckbox from "@/Components/FormCheckbox.vue";
import ContentPaginator from "@/Components/ContentPaginator.vue";

export default {
    name: "StudentVideoFilters",
    emits: ["filters-updated"],
    components: { ContentPaginator, FormCheckbox },
    props: {
        videoFiltersForm: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            focusAreas: this.$page.props.focusAreas,
            videoTypes: this.$page.props.videoTypes,
        };
    },
    methods: {
        resetFilters() {
            this.$inertia.get(route("student.videos.index"));
        },
        toggleCategoriesVisible(focusArea) {
            focusArea.expanded = !focusArea.expanded;
        },
        setCategories() {
            let selectedCategories = [];

            this.focusAreas.forEach(function (focusArea) {
                focusArea.categoriesSelectedCount = 0;

                focusArea.categories.forEach(function (category) {
                    if (category.selected) {
                        selectedCategories.push(category.id);
                        focusArea.categoriesSelectedCount++;
                    }
                });

                focusArea.allCategoriesSelected =
                    focusArea.categoriesSelectedCount ===
                    focusArea.categories.length;
            });

            this.videoFiltersForm.categories = selectedCategories;
        },
        setTypes() {
            let selectedVideoTypes = [];

            this.videoTypes.forEach(function (videoType) {
                if (videoType.selected) {
                    selectedVideoTypes.push(videoType.id);
                }
            });

            this.videoFiltersForm.types = selectedVideoTypes;
        },
        selectAll(focusArea) {
            focusArea.categories.forEach(function (category) {
                category.selected = true;
            });

            this.setCategories();
        },
        deselectAll(focusArea) {
            focusArea.categories.forEach(function (category) {
                category.selected = false;
            });

            this.setCategories();
        },
        populateSelected() {
            let vm = this;
            this.focusAreas.forEach(function (focusArea) {
                focusArea.categories.forEach(function (category) {
                    category.selected = _.includes(
                        vm.videoFiltersForm.categories,
                        category.id
                    );
                });
            });
        },
    },
    mounted() {
        this.populateSelected();
    },
    watch: {
        "videoFiltersForm.categories": {
            handler() {
                this.populateSelected();
            },
            deep: true,
        },
    },
};
</script>
